export default "__VITE_ASSET__Bv3$YfbV__"